const MINUTE = 60 * 1000;

export const CACHE_TTL = {
  Short: MINUTE,
  Default: 5 * MINUTE,
  Long: 30 * MINUTE,
  Day: 24 * 60 * MINUTE,
} as const;

export const CACHE_NAMESPACE = {
  Report: "report",
  ReportTable: "report-table",
  ReportIndicators: "report-indicators",
  StatisticsList: "statistics-list",
  MorningReport: "morning-report",
  SummaryList: "summary-list",
  TrafficProviders: "traffic-providers",
  CampaignList: "campaign-list",
  OfferList: "offer-list",
  TriggerList: "trigger-list",
  CreativeList: "creative-list",
  ReportFilters: "report-filters",
  ReportDisplay: "report-display",
} as const;
